import { render, staticRenderFns } from "./LogoutRoute.vue?vue&type=template&id=2ac4ad03&"
import script from "./LogoutRoute.vue?vue&type=script&lang=ts&"
export * from "./LogoutRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports